// extracted by mini-css-extract-plugin
module.exports = {"searchBarBorder":"pageWrapper_searchBarBorder__Kablb","locked":"pageWrapper_locked__GYRbx","padtop":"pageWrapper_padtop__Ai_dE"};